import { createContext } from 'react';

/** Lets a FileInput tell the post editor that its media is still processing. */
export const MediaProcessingReporterContext = createContext<
    ((key: string, isProcessing: boolean) => void) | null
>(null);
